import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex, IconButton } from "@base-ui";
import { LoadingWithSpinner } from "@animation-ui";
import { useExportPng } from "hooks";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var ExportPngButton = function ExportPngButton(props) {
  var exportRef = props.exportRef,
    fileName = props.fileName,
    className = props.className,
    entry = props.entry;
  var _useExportPng = useExportPng(entry),
    captureScreen = _useExportPng.captureScreen,
    loading = _useExportPng.loading;
  var loader = loading && /*#__PURE__*/_jsx(LoadingWithSpinner, {
    label: "F\xF6rbereder png..."
  });
  return /*#__PURE__*/_jsxs(Flex.Row, _objectSpread(_objectSpread({
    className: "".concat(className || "", " png-ignore hide-while-printing")
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      label: "Exportera png",
      icon: "camera",
      inverted: true,
      mr: "12px",
      onClick: function onClick() {
        return captureScreen(exportRef, fileName);
      }
    }), loader]
  }));
};
ExportPngButton.propTypes = {
  exportRef: PropTypes.any.isRequired,
  fileName: PropTypes.string.isRequired,
  className: PropTypes.string,
  entry: PropTypes.string
};
export default ExportPngButton;